var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "sub_top"
  }, [_c('SubTitle'), _vm._m(0)], 1), _vm._m(1)]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "sub_tit"
  }, [_c('div', {
    staticClass: "sub_tit_inner"
  }, [_c('h2', [_vm._v("운영전략")])])]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "ptc_container"
  }, [_c('div', {
    staticClass: "info_section"
  }, [_c('div', {
    staticClass: "info_txt"
  }, [_c('p', {
    staticClass: "txt_typ_1"
  }, [_c('span', {
    staticClass: "txt_ib"
  }, [_vm._v("측정·분석 프로토콜의")]), _c('span', {
    staticClass: "txt_ib"
  }, [_vm._v("공유와 활용")])])]), _c('div', {
    staticClass: "info_graphic"
  }, [_c('div', {
    staticClass: "info_graphic_img"
  }, [_c('img', {
    attrs: {
      "src": require("@/style/new/images/info/operating_01.png"),
      "alt": ""
    }
  })])])]), _c('div', {
    staticClass: "info_section"
  }, [_c('div', {
    staticClass: "info_txt"
  }, [_c('p', {
    staticClass: "txt_typ_1"
  }, [_vm._v("분야별 핵심요소 기술")])]), _c('div', {
    staticClass: "info_graphic"
  }, [_c('ul', {
    staticClass: "keyelements"
  }, [_c('li', [_c('div', {
    staticClass: "keyelements_card"
  }, [_c('h3', [_vm._v("운영")]), _c('span', {
    staticClass: "icon_1"
  }), _c('ul', {
    staticClass: "keyelements_list"
  }, [_c('li', [_vm._v("연구기반혁신 운영위원회")]), _c('li', [_vm._v("측정분석 협의회(전문위원회)")]), _c('li', [_vm._v("인적 네트워크(분석전문가)")])])])]), _c('li', [_c('div', {
    staticClass: "keyelements_card"
  }, [_c('h3', [_vm._v("시스템")]), _c('span', {
    staticClass: "icon_2"
  }), _c('ul', {
    staticClass: "keyelements_list"
  }, [_c('li', [_vm._v("플랫폼 개발")]), _c('li', [_vm._v("관리/검색체계")]), _c('li', [_vm._v("연구데이터센터 연계")])])])]), _c('li', [_c('div', {
    staticClass: "keyelements_card"
  }, [_c('h3', [_vm._v("측정분석 프로토콜")]), _c('span', {
    staticClass: "icon_3"
  }), _c('ul', {
    staticClass: "keyelements_list"
  }, [_c('li', [_vm._v("요소항목 표준화/수집")]), _c('li', [_vm._v("빅데이터 수집")]), _c('li', [_vm._v("해석데이터 수집")]), _c('li', [_vm._v("프로토콜 수집/활용")])])])]), _c('li', [_c('div', {
    staticClass: "keyelements_card"
  }, [_c('h3', [_vm._v("신측정 분석기술 개발")]), _c('span', {
    staticClass: "icon_4"
  }), _c('ul', {
    staticClass: "keyelements_list"
  }, [_c('li', [_vm._v("미세조직 - 성능 상관관계")]), _c('li', [_vm._v("작동환경 실시간 이미징")]), _c('li', [_vm._v("유연박막전지 소재")]), _c('li', [_vm._v("환경오염인자 고속")])])])])])])]), _c('div', {
    staticClass: "info_section"
  }, [_c('div', {
    staticClass: "info_txt"
  }, [_c('p', {
    staticClass: "txt_typ_1"
  }, [_c('span', {
    staticClass: "txt_ib"
  }, [_vm._v("프로토콜 공유 플랫폼")]), _c('span', {
    staticClass: "txt_ib"
  }, [_vm._v("개발 및 관리/검색 체계")])])]), _c('div', {
    staticClass: "info_graphic"
  }, [_c('ul', {
    staticClass: "search_system"
  }, [_c('li', [_c('div', {
    staticClass: "search_system_card"
  }, [_c('div', {
    staticClass: "search_system_tit"
  }, [_c('h3', [_vm._v("수집 모듈")]), _c('p', [_vm._v("Collection module")])]), _c('ul', {
    staticClass: "search_system_list"
  }, [_c('li', [_vm._v("표준화된 항목DB 구조화")]), _c('li', [_vm._v("메타데이터 간의 연관 관계 DB 구성")]), _c('li', [_vm._v("장비별 데이터 수집 기능")]), _c('li', [_vm._v("자연어처리 기반 데이터 수집 기능")])])])]), _c('li', [_c('div', {
    staticClass: "search_system_card"
  }, [_c('div', {
    staticClass: "search_system_tit"
  }, [_c('h3', [_vm._v("공유 모듈")]), _c('p', [_vm._v("Shared module")])]), _c('ul', {
    staticClass: "search_system_list"
  }, [_c('li', [_vm._v("타 연구자와의 노하우 공유기능(채팅)")]), _c('li', [_vm._v("ReserchGate 등과 같은 SNS기반 연구 공유/협업")]), _c('li', [_vm._v("엠바고 설정 등 보안 기능")])])])]), _c('li', [_c('div', {
    staticClass: "search_system_card"
  }, [_c('div', {
    staticClass: "search_system_tit"
  }, [_c('h3', [_vm._v("활용 모듈")]), _c('p', [_vm._v("Utilization module")])]), _c('ul', {
    staticClass: "search_system_list"
  }, [_c('li', [_vm._v("수록된 노하우 구성요소의 자동시각화")]), _c('li', [_vm._v("수집 한 노하우를 위키디피아 식으로 변환/시각화")]), _c('li', [_vm._v("측정분석데이터 수동/자동 해석기능")])])])]), _c('li', [_c('div', {
    staticClass: "search_system_card"
  }, [_c('div', {
    staticClass: "search_system_tit"
  }, [_c('h3', [_vm._v("검색 모듈")]), _c('p', [_vm._v("Search module")])]), _c('ul', {
    staticClass: "search_system_list"
  }, [_c('li', [_vm._v("ElasticSearch 등 빅데이터 검색 환경")]), _c('li', [_vm._v(" 시멘틱 검색"), _c('br'), _c('span', {
    staticClass: "typ2"
  }, [_vm._v(" -키워드 / 문장 추출,"), _c('br'), _vm._v(" -Sentence to Vector 모델생성"), _c('br'), _vm._v(" -유의어/유사 문장 검색 기능"), _c('br')])]), _c('li', [_vm._v("검색도구 활용효과 증진용 키워드 기계학습 모델 개발")]), _c('li', [_vm._v("연관데이터 검색")])])])]), _c('li', [_c('div', {
    staticClass: "search_system_card"
  }, [_c('div', {
    staticClass: "search_system_tit"
  }, [_c('h3', [_vm._v("관리 모듈")]), _c('p', [_vm._v("Management module")])]), _c('ul', {
    staticClass: "search_system_list"
  }, [_c('li', [_vm._v("데이터 디지털 객체인 식자 (DOI)부여")]), _c('li', [_vm._v("데이터 유통 이력 관리 위·변조 방지")]), _c('li', [_vm._v("데이터의 중복성 및 적정성 검토")])])])])]), _c('div', {
    staticClass: "info_graphic_img"
  }, [_c('img', {
    attrs: {
      "src": require("@/style/new/images/info/operating_02.png"),
      "alt": ""
    }
  })]), _c('p', {
    staticClass: "desc_txt"
  }, [_vm._v(" 국가 소재연구데이터센터 및 DB간 데이터 (API 개발 및 표 준코드 제정 및 부여), "), _c('br'), _vm._v(" 외부 DB(소재정보은행, 국외 DB 등) 데이터 연계활용환경 구축 ")])])])]);

}]

export { render, staticRenderFns }